export const scriptLoader = src => {     
  // 加入 script 標籤
  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = src;
  document.body.appendChild(script);
  return script; // 返回 script 元素以便追蹤和移除
};